import { Button as MuiButton } from '@mui/material';
import styled from '@mui/material/styles/styled';

export const Button = styled(MuiButton)(() => ({
    borderRadius: 10,
    minWidth: 0,
    width: '200px !important',
    height: '65px !important',
    border: '3px solid #649CD7',
    textTransform: 'capitalize',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 20px',
}));
